import React from "react";
import ReactDOM from "react-dom/client";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import AdminPage from "./AdminPage";
import App from "./App";
import LoginPage from "./LoginPage";
import UserPage from "./UserPage";
import ProtectedRoute from "./components/ProtectedRoute";
import "./index.css";
import { AuthProvider } from "./AuthContext";
import reportWebVitals from './reportWebVitals';
import UserManagement from "./UserManagement";
import LocationManagement from "./LocationManagement";
import GroupManagement from "./GroupManagement";
import LeaveManagement from "./pages/admin/LeaveManagement";

//UserPage
import UserDashboard from "./pages/user/UserDashboard";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="/login" element={<LoginPage />} />

          <Route element={<ProtectedRoute allowedRoles={["superadmin", "admin"]} />}>
            <Route path="/admin" element={<AdminPage />} />
          </Route>
          <Route element={<ProtectedRoute allowedRoles={["superadmin"]} />}>
            <Route path="/admin/user-management" element={<UserManagement />} />
          </Route>
          <Route element={<ProtectedRoute allowedRoles={["superadmin"]} />}>
            <Route path="/admin/group-management" element={<GroupManagement />} />
          </Route>
          <Route element={<ProtectedRoute allowedRoles={["superadmin"]} />}>
            <Route path="/admin/location-management" element={<LocationManagement />} />
          </Route>
          <Route element={<ProtectedRoute allowedRoles={["superadmin"]} />}>
            <Route path="/admin/leave-management" element={<LeaveManagement />} />
          </Route>
          <Route element={<ProtectedRoute allowedRoles={["superadmin", "admin", "employee"]} />}>
            <Route path="/userv2" element={<UserPage />} />
          </Route>
          <Route element={<ProtectedRoute allowedRoles={["superadmin", "admin", "employee"]} />}>
            <Route path="/user" element={<UserDashboard />} />
          </Route>
        </Routes>
      </AuthProvider>
    </Router>
  </React.StrictMode>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
